import api from "../../Hooks/axiosApi";

export const getClientMMPIncomeExpensesByClientId = (id: string) => {
    const response = api.get(`/api/MppClient/GetClientMMPIncomeExpensesByClientId/${id}`);
    return response;
};
export const insertClientMMPIncomeExpenses = (formData: any) => {
    const response = api.post(`/api/MppClient/InsertClientMMPIncomeExpenses`, formData);
    return response;
};

export const upsertClientMMPIncomeExpenseDetails = (formData: any) => {
    const response = api.post(`/api/MppClient/UpsertClientMMPIncomeExpensedetails`, formData);
    return response;
};

export const getClientMMPIncomeExpenseDetailsByClientId = (clientId: string) => {
    const response = api.get(`/api/MppClient/GetGetClientMMPIncomeExpenseDetailsByClientId/${clientId}`);
    return response;
};

export const getDashboardService = (clientId: string) => {
    const response = api.get(`/api/ClientDasboard/${clientId}`);
    return response;
};